import './bootstrap/imgix'
import './bootstrap/site'
import './bootstrap/searchTracking'
import 'lazysizes'
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import algoliaResourceSearch from './components/algoliaResourceSearch'

window.Alpine = Alpine;

Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(intersect)
Alpine.data('algoliaResourceSearch', algoliaResourceSearch)
Alpine.start()

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}